import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route guard for the Teacher Portal.
 * Requires the user to be authenticated and hold an active course_admin or org_admin
 * membership in at least one organization. Global admins always pass.
 */
function TeacherRoute({ children }) {
  const { user, isInitialized, hasAnyOrgAdminRole } = useAuth();

  if (!isInitialized) {
    return (
      <div className="loading-auth">
        <div className="loading-spinner"></div>
        <p>Checking permissions...</p>
      </div>
    );
  }

  const isGlobalAdmin = user?.roles?.some(r => r.roleName === 'admin');
  if (isGlobalAdmin) return children;

  // Dev bypass for teacher portal testing
  const allowedEmails = ['alan@docuhounds.com'];
  if (allowedEmails.includes(user?.email?.toLowerCase())) return children;

  if (!hasAnyOrgAdminRole()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default TeacherRoute;
